import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from '../../../services/excel/excel.service';
import Swal from 'sweetalert2';
import { IMG } from '../../../services/imagen/png';
import { CuadroMandoIntegralService } from '../../../services/seguimiento/cuadro-mando-integral/cuadro-mando-integral.service';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import moment from 'moment';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { IndicadorService } from '../../../services/gestion/indicadores/indicador.service';
import html2canvas from 'html2canvas';
import { messages } from '../../funciones/mensajes';

@Component({
  selector: 'app-cuadro-mando-integral',
  templateUrl: './cuadro-mando-integral.component.html',
  styleUrl: './cuadro-mando-integral.component.css'
})
export class CuadroMandoIntegralComponent implements OnInit {
  public Filters = FiltersM;

  public Nombre = 'CMI';
  public acum = true;
  public viewTablero = false;
  public tarjets = [1,2,3]

  // Filtros
  public todasPer = true;
  public aniosDisponibles: any = [];
  public perspectives: any = [];

  // Variables planeación
  private planeacionID: number = 0;
  public avancePlan = 0;
  public diccionarioPer: any[] = [];
  private semaforo: any[] = [];

  public indicadores: any = [];
  public objectivos: any = [];
  public indicadoresMostrar: any = [];


  private mensajes = [
    'mens1',
    'mens2',
    'mens3'
  ];

  public mision = undefined;
  public vision = undefined;
  public textoMostrar = 'Texto informativo';
  public tarjOrTab = true;
  public expandirObj = false;
  public verCodigo = false;



  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private excelService: ExcelService,
    // private cuadromandoService: CuadroMandoIntegralService,
    private cookies: CookieService,

    private planificacionService: PlanificacionService,
    private objetivoService: ObjetivoService,
    private indicadorService: IndicadorService,
  ) {
    this.consultas();
  }

  ngOnInit(): void { }

  private async consultas() {
    this.planeacionID = Number(this.cookies.get('idInstitucion'));

    try {
      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(this.planeacionID);
      this.obtenerFiltros(planeacionResponse);
      
      this.perspectives = this.ordenamientoId(this.perspectives);

      const objectives = [];
      for(const per of this.perspectives){
        const obj = await this.objetivoService.getObjectivesByPerspectiveGQL(per.id);
        objectives.push(...obj)
      }
      this.diccionario(objectives);

      const indicators = [];
      for(const obj of this.objectivos){
        const ind = await this.indicadorService.getIndicadoresByObjetiveGQL(Number(obj.id));
        indicators.push(...ind)
      }
      this.obtenerIndicadores(indicators.flat());

    } catch (error) {
      // Aquí podrías añadir un manejo de errores más específico si es necesario
    }
  }

  private seleccionarPeriodo(){
    this.aniosDisponibles.forEach(a => {
      a.series.forEach(m => m.check = false);
    });
    const ultimoAnio = this.aniosDisponibles[this.aniosDisponibles.length - 1];
    const ultimoPeriodo = ultimoAnio.series[ultimoAnio.series.length - 1];

    const periodoActual = moment().format('MMM-YY').toLowerCase();

    if (ultimoPeriodo.periodo === periodoActual) {
      const series = ultimoAnio.series;
      const indice = series.length - 1;

      if (indice > 0) {
        series[indice - 1].check = true;
      }
    } else {
      ultimoPeriodo.check = true;
    }
  }
  private obtenerFiltros(plan: any) {
    if (plan.institution.acronym === 'IDemo' || plan.institution.acronym === 'Bienestar') {
      //this.verCodigo = true;
    }
    this.aniosDisponibles = Meses.obtenerPeriodos(moment(plan.initial_date).toDate(), moment(plan.end_date).toDate());
    
    this.seleccionarPeriodo();

    if (plan.philosophies && Array.isArray(plan.philosophies)) {
      const fil = this.ordenamientoId([...plan.philosophies]); // Clonar para evitar mutaciones inesperadas
      if (fil.length > 0) {
        this.mision = fil[0];
      }
      if (fil.length > 1) {
        this.vision = fil[1];
      }
    }

    for (const per of plan.perspectives) {
      this.perspectives.push({
        name: per.name,
        id: per.id,
        check: true,
      });
    }
    
    // Agregar visible: true a todos los años y meses
    for (const anio of this.aniosDisponibles) {
      anio.visible = true;
      for (const mes of anio.series) {
        mes.visible = true;
      }
    }

    const sema = this.ordenamientoSem([].concat(plan.signals));
    for (const sem of sema) {
      this.semaforo.push({
        valIn: Number(sem.value_00),
        valfin: Number(sem.value_01),
        color: sem.color[0],
      });
    }
  }
  private diccionario(array: any) {
    var auxPer: any = [], auxO = [];
    var dicci: any = [];

    for (const per of this.perspectives) {
      for (const obj of array) {
        if (Number(per.id) === Number(obj.perspective.id)) {
          auxPer.push({
            name: obj.name,
            id: obj.id,
            weighing: obj.weighing,
            avance: 0,
            check: false,
          });
          auxO.push({
            nombre: obj.name,
            id: obj.id,
            idPer: obj.perspective.id,
            peso: obj.weighing,
            indicadores: [],
          });
        }
      }
      dicci.push({ perspective: per, objetivos: auxPer });
      auxPer = [];
    }
    this.objectivos = [];
    this.objectivos = auxO;
    this.objectivos = this.ordenamientoId(this.objectivos);
    this.diccionarioPer = dicci;

    var aux = 0;
    for (const per of this.diccionarioPer) {
      for (const obj of per.objetivos) {
        aux += Number((obj.data * obj.weighing / 100).toFixed(2));
      }
    }
  }
  private obtenerIndicadores(array: any) {
    var aux = [];
    for (const ind of array) {
      for (const obj of this.objectivos) {
        if (Number(ind.objective.id) === Number(obj.id)) {
          var metas = [];
          for (const met of ind.goals) {
            metas.push({
              id: met.id,
              period: met.period,
              value: met.value,
              real: met.real,
            });
          }
          aux.push({
            nombre: ind.name,
            id: ind.id,
            ponderacion: ind.weighing,
            metas: this.ordenamientoMetas(metas),
            tendencia: ind.tendency,
            objectiveId: ind.objective,
            fechaIni: ind.initialDate,
            fechaFin: ind.endDate,
            areaId: ind.area.id,
          });
          break;
        }
      }
    }
    this.indicadores = [];
    this.indicadores = aux;
    this.indicadores = this.ordenamientoId(this.indicadores);
    this.indicadores = this.ordenamientoObjId(this.indicadores);

    if (this.acum) {
      this.indicadoresMostrar = [].concat(this.indicadores);
    } else {
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
    }

    this.obtAvance();
    this.obtenerIndicadoresObj();
    this.viewTablero = true;

  }
  private obtenerIndicadoresObj() {
    for (const per of this.diccionarioPer) {
      for (const obj of per.objetivos) {
        var indEx = this.indicadores.filter(ind => ind.objectiveId.id === obj.id);
        if (indEx.length !== 0) {
          var indicators = [];
          for (const ind of indEx) {
            indicators.push({
              nombre: ind.nombre,
              avance: this.acum ? this.porcentajeIndAcum(ind) : this.porcentajeInd(ind),
            })
          }
          obj.indicadores = indicators;
        }
      }
    }
  }
  private obtAvance() {
    if (this.acum) {
      this.avancePlan = this.porcentajeObjecAcum();
    } else {
      this.avancePlan = this.porcentajeObjec();
    }
    this.diccionarioPer
    for (const per of this.diccionarioPer) {
      for (const obj of per.objetivos) {
        var avance = 0;
        if (this.acum) {
          avance = this.porcentajeObjAcum(obj.id);
        } else {
          avance = this.porcentajePers(obj.id);
        }
        obj.avance = avance;
      }
    }
  }
  // filtros
  public anioChange(periodoOData: any) {
    // Si recibe un objeto, extraer el periodo; si es string, usarlo directamente
    const periodo = typeof periodoOData === 'string' ? periodoOData : periodoOData.periodo;

    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        mes.periodo === periodo ? mes.check = true : mes.check = false;
      }
    }

    if (this.acum) {
      this.indicadoresMostrar = [].concat(this.indicadores);
    } else {
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
    }

    this.obtAvance();
    this.obtenerIndicadoresObj();
  }

  public persChange(pers: any) {
    if(pers === 'consolidado'){
      this.selecAllPer();
    }
    var sel = 0;
    for (const per of this.diccionarioPer) {
      per.perspective.id === pers.id ? per.perspective.check = !per.perspective.check : per.perspective.check = per.perspective.check;
      if (per.perspective.check) {
        sel++;
      }
    }
    if (sel === this.diccionarioPer.length) {
      this.todasPer = true;
    } else {
      this.todasPer = false;
    }


    if (this.acum) {
      this.indicadoresMostrar = [].concat(this.indicadores);
    } else {
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
    }

    this.obtAvance();
    this.obtenerIndicadoresObj();
  }

  public selecAllPer() {
    this.todasPer = !this.todasPer;
    for (const per of this.diccionarioPer) {
      if (this.todasPer) {
        per.perspective.check = true;
      } else {
        per.perspective.check = false;
      }
    }

    if (this.todasPer) {
      if (this.acum) {
        this.indicadoresMostrar = [].concat(this.indicadores);
      } else {
        this.indicadoresMostrar = [];
        for (const ind of this.indicadores) {
          if (this.Mostrar(ind)) {
            this.indicadoresMostrar.push(ind);
          }
        }
      }
      this.obtAvance();
      this.obtenerIndicadoresObj();
    }
  }
  // Metodo mostrar
  public Mostrar(ind: any) {
    // Observar que exista al menos una meta en los periodos
    var perSele = [];
    var metasInd = [];
    var existeMet = false;
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          perSele.push(mes.periodo);
        }
      }
    }
    for (const met of ind.metas) {
      metasInd.push(Meses.getMesesN(this.obtFech(met.period).getMonth() + 1) + '-' + (this.obtFech(met.period).getFullYear() + '').substring(2, 4));
    }
    for (const per of metasInd) {
      for (const perS of perSele) {
        if (per === perS) {
          existeMet = true;
        }
      }
    }

    //Observar que la perspectiva este activa
    var existPer = false, perInd;
    for (const obj of this.objectivos) {
      if (obj.id === ind.objectiveId.id) {
        perInd = this.obtPer(obj.idPer);
      }
    }

    if (this.todasPer) {
      existPer = true;
    } else {
      for (const per of this.perspectives) {
        if (per.check && per.name === perInd) {
          existPer = true;
        }
      }
    }

    if (existeMet && existPer)
      return true;
    return false;
  }
  public mostrarPers(pers: any) {
    var perSelected = 0;
    for (const per of this.diccionarioPer) {
      if (per.perspective.check) {
        perSelected++;
      }
    }
    if (this.todasPer || perSelected === 0) {
      return true;
    } else if (pers.perspective.check) {
      return true;
    }
    return false;
  }
  private obtFech(isodate: any) {
    return moment(isodate).toDate();
  }
  // obtencion de nombres
  private obtPer(perId: any) {
    for (const per of this.perspectives) {
      if (per.id === perId) {
        return per.name
      }
    }
  }
  public perSelected() {
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          return mes.periodo;
        }
      }
    }
    return '';
  }
  //Tarjetas
  public pintarBorde(valor: any) {
    if (valor != 0) {
      var color = '', valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (valor >= valfin) {
        valor = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (valor >= ab && valor <= sem.valfin) {
          color = sem.color;
          break;
        }
      }
      switch (color) {
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default: return 'bordeGrey';
      }
    } else {
      return 'bordeGrey';
    }
  }
  public texto(valor: any) {
    var color = '', valfin = 0;

    if (valor !== 0) {
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (valor >= valfin) {
        valor = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (valor >= ab && valor <= sem.valfin) {
          color = sem.color;
          break;
        }
      }
    }

    switch (color) {
      case 'verde': return 'cifraSecVerd';
      case 'azul': return 'cifraSecAzul';
      case 'amarillo': return 'cifraSecAmar';
      case 'naranja': return 'cifraSecNarj';
      case 'rojo': return 'cifraSecRojo';
      default: return 'cifraSecGris';
    }
  }
  //Rutas
  /*
  todo:
  public rutas(direc: string) {
    if (direc === 'avanzar')
      this.router.navigateByUrl('/app/' + 'seguimiento/' + 'objetivos/' + this.planeacionID);
  }
  */
  // Metodos de ordenamiento
  public ordenamientoId(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoObjId(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.objectiveId.id) > Number(b.objectiveId.id)) {
        return 1;
      }
      if (Number(a.objectiveId.id) < Number(b.objectiveId.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoMetas(array: any) {
    array.sort(function (a: any, b: any) {
      if ((a.period) > (b.period)) {
        return 1;
      }
      if ((a.period) < (b.period)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public ordenamientoSem(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.value_00) > Number(b.value_00)) {
        return 1;
      }
      if (Number(a.value_00) < Number(b.value_00)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  // Datos de tarjetas
  public escribirPerT(ind: any, i: any) {
    var perid1;
    for (const obj of this.objectivos) {
      if (obj.id === ind.objectiveId.id) {
        perid1 = obj.idPer;
      }
    }
    return this.obtPer(perid1);

  }
  //Porcentajes acumulados
  public porcentajeObjecAcum() {
    var persPon = 0, perTot = 0;

    var pesoFin = 0;
    for (const obj of this.objectivos) {
      var por = this.porcentajeObjAcum(obj.id), porcentajeObj = obj.peso;
      if (por != undefined) {
        pesoFin += obj.peso;
        persPon += por * porcentajeObj / 100;
      }
    }
    if (persPon !== 0) {
      persPon = persPon * 100 / pesoFin;
    }

    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin;
      }
    }
    if (persPon >= valfin) {
      persPon = valfin;
    }
    return Number((persPon).toFixed(0));
  }
  public porcentajePersAcum(nomPer: string) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    let fechaPer = this.fechaMeta(persel);
    var porcentaje = 0;
    let pesoPer = 0, peso = 0;

    for (const obj of this.objectivos) {
      if (Number(obj.idPer) === Number(nomPer)) {
        for (const ind of this.indicadores) {
          var per = this.escribirPerT(ind, i), pondInd = this.obtenerPondIndAcum(ind);
          let metas = ind.metas;
          for (var i = metas.length - 1; i >= 0; i--) {
            const peer = ind.metas[i].period;
            if (fechaPer === peer && Number(obj.id) === Number(ind.objectiveId.id)) {
              const val = this.escribirReal(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
              const met = this.escribirMeta(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
              var porcen = undefined;
              let dat = this.rendimiento(val, met, ind).split('%');
              porcen = Number(dat[0]);
              if (isNaN(val) || isNaN(Number(dat[0]))) {
                porcen = undefined;
              }
              if (porcen !== undefined) {
                var valfin = 0;
                for (const sem of this.semaforo) {
                  if (valfin < sem.valfin) {
                    valfin = sem.valfin;
                  }
                }
                if (porcen >= valfin) {
                  porcen = valfin;
                }

                porcen = porcen * pondInd / 100;
                porcentaje += porcen;
                metasTot++;
                porcen = 0;
              }
              break;
            } else if (fechaPer > peer && metas[i].real !== null && Number(obj.id) === Number(ind.objectiveId.id) && Number(peer.split('-')[0]) === Number(fechaPer.split('-')[0])) {
              const val = this.escribirReal(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
              const met = this.escribirMeta(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
              var porcen = undefined;
              let dat = this.rendimiento(val, met, ind).split('%');
              porcen = Number(dat[0]);
              if (isNaN(val) || isNaN(Number(dat[0]))) {
                porcen = undefined;
              }
              if (porcen !== undefined) {
                var valfin = 0;
                for (const sem of this.semaforo) {
                  if (valfin < sem.valfin) {
                    valfin = sem.valfin;
                  }
                }
                if (porcen >= valfin) {
                  porcen = valfin;
                }

                porcen = porcen * pondInd / 100;
                porcentaje += porcen;
                metasTot++;
              } else {
                porcen === 0;
              }
              break;
            }
          }
        }
        if (porcentaje !== 0) {
          peso += porcentaje * obj.peso / 100;
          pesoPer += obj.peso;
        }
        porcentaje = Number(porcentaje.toFixed(0));
        porcentaje = 0;
      }
    }
    porcentaje = peso * 100 / pesoPer;

    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin
      }
    }
    if (porcentaje >= valfin) {
      porcentaje = valfin;
    }
    if (metasTot !== 0)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
    return 0
  }
  private obtenerPondIndAcum(ind: any) {
    var Nind = 0;
    for (const indi of this.indicadores) {
      if (Number(ind.objectiveId.id) === Number(indi.objectiveId.id) && this.porcentajeIndAcum(indi) !== undefined) {
        Nind += indi.ponderacion;
      }
    }
    if (isNaN(ind.ponderacion * 100 / Nind)) {
      return 0;
    }
    return ind.ponderacion * 100 / Nind;
  }
  private porcentajeIndAcum(ind: any) {
    var persel = this.perSelected(), metasTot = 0;
    let fechaPer = this.fechaMeta(persel);
    var porcentaje = undefined;
    for (var i = ind.metas.length - 1; i >= 0; i--) {
      const peer = ind.metas[i].period;
      if (fechaPer === peer) {
        const val = this.escribirReal(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
        const met = this.escribirMeta(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
        let dat = this.rendimiento(val, met, ind).split('%');
        porcentaje = Number(dat[0]);
        if (isNaN(val) || isNaN(Number(dat[0]))) {
          porcentaje = undefined;
        }
        if (porcentaje !== undefined) {
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          if (porcentaje >= valfin) {
            porcentaje = valfin;
          }
        } else {
          porcentaje === 0;
        }
        break;
      } else if (fechaPer > peer && ind.metas[i].real !== null && Number(peer.split('-')[0]) === Number(fechaPer.split('-')[0])) {
        const val = this.escribirReal(Meses.obtnerPer(this.obtFech(ind.metas[i].period)), ind);
        const met = this.escribirMeta(Meses.obtnerPer(this.obtFech(ind.metas[i].period)), ind);
        let dat = this.rendimiento(val, met, ind).split('%');
        porcentaje = Number(dat[0]);
        if (isNaN(val) || isNaN(Number(dat[0]))) {
          porcentaje = undefined;
        }
        if (porcentaje !== undefined) {
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          if (porcentaje >= valfin) {
            porcentaje = valfin;
          }
        }
        break;
      }
    }
    if (porcentaje !== undefined)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
  }
  public porcentajeObjAcum(objId: string) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    let fechaPer = this.fechaMeta(persel);
    var porcentaje = 0;


    for (const ind of this.indicadores) {
      var per = this.escribirPerT(ind, i), pondInd = this.obtenerPondIndAcum(ind);
      let metas = ind.metas;
      for (var i = metas.length - 1; i >= 0; i--) {
        const peer = ind.metas[i].period;
        if (fechaPer === peer && Number(objId) === Number(ind.objectiveId.id)) {
          const val = this.escribirReal(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
          const met = this.escribirMeta(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
          var porcen = undefined;
          let dat = this.rendimiento(val, met, ind).split('%');
          porcen = Number(dat[0]);
          if (isNaN(val) || isNaN(Number(dat[0]))) {
            porcen = undefined;
          }
          if (porcen !== undefined) {
            var valfin = 0;
            for (const sem of this.semaforo) {
              if (valfin < sem.valfin) {
                valfin = sem.valfin;
              }
            }
            if (porcen >= valfin) {
              porcen = valfin;
            }
            porcen = porcen * pondInd / 100;
            porcentaje += porcen;
            metasTot++;
          } else {
            porcen === 0;
          }
          break;
        } else if (fechaPer > peer && metas[i].real !== null && Number(objId) === Number(ind.objectiveId.id) && moment(peer).year() === moment(fechaPer).year()) {
          const val = this.escribirReal(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
          const met = this.escribirMeta(Meses.obtnerPer(moment(ind.metas[i].period).toDate()), ind);
          var porcen = undefined;
          let dat = this.rendimiento(val, met, ind).split('%');
          porcen = Number(dat[0]);
          if (isNaN(val) || isNaN(Number(dat[0]))) {
            porcen = undefined;
          }
          if (porcen !== undefined) {
            var valfin = 0;
            for (const sem of this.semaforo) {
              if (valfin < sem.valfin) {
                valfin = sem.valfin;
              }
            }
            if (porcen >= valfin) {
              porcen = valfin;
            }
            porcen = porcen * pondInd / 100;
            porcentaje += porcen;
            metasTot++;
          } else {
            porcen === 0;
          }
          break;
        }
      }
    }

    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin
      }
    }
    if (porcentaje >= valfin) {
      porcentaje = valfin;
    }
    if (metasTot !== 0)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
    return 0
  }

  // Porcentajes normales
  public porcentajeObjec() {
    var persPon = 0, perTot = 0;

    var pesoFin = 0;
    for (const obj of this.objectivos) {
      var por = this.porcentajePers(obj.id), porcentajeObj = obj.peso;
      if (por != undefined) {
        pesoFin += obj.peso;
        persPon += por * porcentajeObj / 100;
      }
    }
    if (persPon !== 0 && pesoFin !== 0) {
      persPon = persPon * 100 / pesoFin;
    } else {
      persPon = null;
    }
    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin;
      }
    }
    if (persPon >= valfin) {
      persPon = valfin;
    }
    if (persPon !== null) {
      return Number((persPon).toFixed(0));
    }
    return null;
  }
  public porcentajePers(nomPer: string) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    var porcentaje = 0;
    for (const ind of this.indicadoresMostrar) {
      var per = this.escribirPerT(ind, i), pondInd = this.obtenerPondInd(ind);
      for (const meta of ind.metas) {
        if (persel === Meses.obtnerPer(moment(meta.period).toDate()) && Number(nomPer) === Number(ind.objectiveId.id)) {
          const val = this.escribirReal(persel, ind), met = this.escribirMeta(persel, ind);
          var porcen = undefined;
          let dat = this.rendimiento(val, met, ind).split('%');
          porcen = Number(dat[0]);
          if (isNaN(val) || isNaN(Number(dat[0]))) {
            porcen = undefined;
          }
          if (porcen !== undefined) {
            var valfin = 0;
            for (const sem of this.semaforo) {
              if (valfin < sem.valfin) {
                valfin = sem.valfin;
              }
            }
            if (porcen >= valfin) {
              porcen = valfin;
            }

            porcen = porcen * pondInd / 100;
            porcentaje += porcen;
            metasTot++;
          }
          break;
        }
      }
      i++;
    }

    var valfin = 0;
    for (const sem of this.semaforo) {
      if (valfin < sem.valfin) {
        valfin = sem.valfin
      }
    }
    if (porcentaje >= valfin) {
      porcentaje = valfin;
    }
    if(isNaN(porcentaje)){
      return 0;
    }
    if (metasTot !== 0)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
    return 0
  }
  private obtenerPondInd(ind: any) {
    var Nind = 0;
    for (const indi of this.indicadoresMostrar) {
      if (ind.objectiveId.id === indi.objectiveId.id) {
        Nind += indi.ponderacion;
      }
    }
    return ind.ponderacion * 100 / Nind;
  }
  private porcentajeInd(ind: any) {
    var persel = this.perSelected(), i = 0, metasTot = 0;
    var porcentaje = undefined;
    for (const meta of ind.metas) {
      if (persel === Meses.obtnerPer(moment(meta.period).toDate())) {
        const val = this.escribirReal(persel, ind), met = this.escribirMeta(persel, ind);
        let dat = this.rendimiento(val, met, ind).split('%');
        porcentaje = Number(dat[0]);
        if (isNaN(val) || isNaN(Number(dat[0]))) {
          porcentaje = undefined;
        }
        if (porcentaje !== undefined) {
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          if (porcentaje >= valfin) {
            porcentaje = valfin;
          }
        }
      }
    }
    if (porcentaje !== undefined)
      return Number(porcentaje.toFixed(0));//*100/ponderacionPer
    else {
      return undefined
    }
  }
  private obtenerPonder(obj: any) {
    var ponderacionPer = 0;
    var i = 0, objList: any = [];

    for (const ind of this.indicadoresMostrar) {
      if (!objList.includes(ind.objectiveId.id)) {
        objList.push(ind.objectiveId.id);
      }
    }
    for (const obj of this.objectivos) {
      if (objList.includes(obj.id)) {
        ponderacionPer += obj.peso;
      }
    }
    return obj.peso * 100 / ponderacionPer;
  }

  private fechaMeta(periodo) {
    let fecha = new Date('01-' + Meses.getMesesNum(periodo.split('-')[0]) + '-' + periodo.split('-')[1]);
    return moment(fecha).format("YYYY-DD-MM");
  }

  public rendimiento(real: any, value: any, ind) {
    const met = { real: real === null ? null : real, value: value === null ? null : value };
    if (met.real < 0 && met.value >= 0) {
      switch (ind.tendencia) {
        case '-1':
          const sem = this.semaforo.filter(sem => sem.valfin >= 100);
          return sem[0].valfin + ' %';
        case '1':
        case '0':
          return '0 %';
      }
    } else if (met.value < 0.0 && met.real !== null) {
      switch (ind.tendencia) {
        case '-1':
          if (met.real > 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return 0 + ' %';
          } else if (met.value <= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value > met.real) {
            let rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
            if (rendimiento < 0) { rendimiento = 0; }
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
        case '1':
        case '0':
          if (met.real > 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value >= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value < met.real) {
            let rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
      }
    } else if (met.value !== 0 && met.real !== 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
          break;
        case '1':
        case '0':
          rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
          break;
      }
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin;
        }
      }
      if (rendimiento >= valfin) {
        rendimiento = valfin;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value !== 0 && met.real === 0) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          rendimiento = valfin;
          break;
        case '1':
        case '0':
          rendimiento = 0;
          break;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value === 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real <= 0) {
            return 100 + ' %';
          } else if (met.real > 0) {
            return 0 + ' %';
          }
          break;
        case '1':
        case '0':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real >= 0) {
            return 100 + ' %';
          } else if (met.real < 0) {
            return 0 + ' %';
          }
          break;
      }
    } else if (met.value === 0 && met.real === null) {
      switch (ind.tendencia) {
        case '-1':
          return 0 + ' %';
        case '1':
        case '0':
          return 0 + ' %';
      }
    } else if (met.value !== 0 && met.real === null) {
      return '0 %';
    }
    return '';
  }
  public escribirMeta(periodo: any, ind: any) {
    var nombre = '';
    for (const met of ind.metas) {
      const fechaMeta = moment(met.period);
      nombre = Meses.getMesesN(fechaMeta.month() + 1) + '-' + fechaMeta.format('YY');
      if (nombre === periodo) {
        return met.value;
      }
    }
    return ''
  }
  public escribirReal(periodo: any, ind: any) { //avance
    var nombre = '';
    for (const met of ind.metas) {
      const fechaMeta = moment(met.period);
      nombre = Meses.getMesesN(fechaMeta.month() + 1) + '-' + fechaMeta.format('YY');
      if (nombre === periodo) {
        return met.real;
      }
    }
    return ''
  }
  public async modalInd(obj: any) {
    var nombreObj = obj.name, indicadores = [];

    try {
      const response = await this.indicadorService.getIndicadoresByObjetiveGQL(obj.id);
      indicadores = [];
      for (const ind of response) {
        indicadores.push({
          nombre: ind.name,
        });
      }
      indicadores = this.ordenamientoPer(indicadores);

      var html = '<div class="w3-row">' +
        '<div class="w3-row">' +
        '  <div style="text-align: justify; margin-left: 1vw; margin-right: 2vw;"> Indicadores asociados </div>' +
        '</div>' +
        '<mat-list style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">';

      for (const ind of indicadores) {
        html += '<div mat-line style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">' +
          '<span style="color: #ff6b00">&#8226;</span>' +
          (this.verCodigo ? 'Código | ' : '') + ' ' + ind.nombre +
          '</div>';
      }
      html += '</mat-list>' + '</div>';

      var ancho = 'auto';
      if (nombreObj.length > 100) {
        ancho = '60%'
      }

      await Swal.fire({
        title: '' + nombreObj,
        html: html,
        showConfirmButton: false,
        width: ancho + '',
      });
    } catch (error) {
    }
  }
  public modalInfo(number: any) {
    this.textoMostrar = this.mensajes[number];
    Swal.fire({
      title: this.translate.instant('gestion.seguimiento.cmi.info'),
      text: this.translate.instant('gestion.seguimiento.cmi.' + this.mensajes[number]),
      iconColor: '#ff6b00',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
    });
  }
  private ordenamientoPer(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  public async exportarImge(id: string, graf: string) {
    var grafica: string = "";
    var name: string = "";

    switch (graf) {
      case 'per':
        grafica = 'graf' + id;
        name = '' + id;
        IMG.exportimagenes(grafica, name);
        break;
      case 'prin':
        break;
      case 'tot':
        messages.messageSaving(this.translate.instant('swal.generandoImg'),this.translate.instant('swal.espere'));
        grafica = id;
        name = 'CMI';
        const element = document.getElementById(grafica);
        const clone = element.cloneNode(true) as HTMLElement;

        clone.style.position = 'absolute';
        clone.style.left = '0';
        clone.style.top = '0';
        clone.style.transform = 'translateX(-10000px)';

        clone.style.height = 'auto';
        clone.style.maxHeight = 'none';
        clone.style.overflow = 'visible';

        clone.style.padding = '20px';
        clone.style.background = '#ffffff';
        clone.style.boxSizing = 'border-box';

        document.body.appendChild(clone);

        const canvas = await html2canvas(clone, {
            backgroundColor: '#ffffff',
            scale: window.devicePixelRatio,
            useCORS: true,
            logging: false
        });
        const link = document.createElement('a');
        link.download = `${name}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();

        document.body.removeChild(clone);
        Swal.close();
        break;
    }
  }
  /** Cambio de tarjetas a tablas */
  public cambioTarjTab() {
    this.tarjOrTab = !this.tarjOrTab;
  }
  public pintarBordes(i: number) {
    if (i === 0) {
      return 'borderSup';
    }
    return '';
  }
  /* Abrir y cerrar los proyectos */
  public oculMost(obj: any) {
    obj.check = !obj.check;
    var check = 0;
    for (const per of this.diccionarioPer) {
      for (const ob of per.objetivos) {
        if (ob.check) {
          check++;
        }
      }
    }
    if (check === this.objectivos.length) {
      this.expandirObj = true;
    } else if (check === 0) {
      this.expandirObj = false;
    }
  }
  public oculMostAll() {
    for (const per of this.diccionarioPer) {
      for (const obj of per.objetivos) {
        if (this.expandirObj) {
          obj.check = false;
        } else {
          obj.check = true;
        }
      }
    }
    this.expandirObj = !this.expandirObj;
  }
  public exportarExcelTab() {
    const title = '' + this.translate.instant('menu.cuadro-mando');
    var header = ["" + this.translate.instant('gestion.seguimiento.cmi.persp'),
    "" + this.translate.instant('gestion.seguimiento.cmi.objec') + ' / ' + this.translate.instant('gestion.seguimiento.cmi.indic'),
    "" + this.translate.instant('gestion.seguimiento.cmi.avanc')];
    var data = [];
    var aux = [], i = 0;
    for (const per of this.diccionarioPer) {
      for (const obj of per.objetivos) {
        aux.push(i === 0 ? per.perspective.name : '');
        aux.push(obj.name);
        aux.push(obj.avance !== undefined ? obj.avance / 100 : '');
        data.push(aux);
        i++;
        aux = [];
        if (obj.indicadores !== undefined) {
          for (const ind of obj.indicadores) {
            aux.push('');
            aux.push('- ' + (this.verCodigo ? 'Código | ' : ' ') + '' + ind.nombre);
            aux.push(ind.avance !== undefined ? ind.avance / 100 : '');
            data.push(aux);
            aux = [];
          }
        }
      }
      i = 0;
    }
    const NomArch = '' + this.translate.instant('menu.cuadro-mando');
    this.excelService.generateExcelCMISeguimiento(title, header, data, NomArch, this.semaforo);
  }
  /* Cambio en el avance */
  public changeAvance() {
    this.acum = !this.acum;
    if (this.acum) {
      this.indicadoresMostrar = [].concat(this.indicadores);
    } else {
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
    }
    this.obtAvance();
    this.obtenerIndicadoresObj();
  }
  /* formateo de datos */
  public escrituraPeriodo(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    }
    return Periodo;
  }

  public borrarFiltros(){
    this.todasPer = true;

    var per = this.aniosDisponibles[this.aniosDisponibles.length-1].series[this.aniosDisponibles[this.aniosDisponibles.length-1].series.length-1]; 
    const Periodo = per.periodo;
    for(const an of this.aniosDisponibles){
      for(const mes of an.series){
        if(mes.periodo !== Periodo){
          mes.check = false;
        }else{
          mes.check = true;
        }
      }
    }

    if (this.acum) {
      this.indicadoresMostrar = [].concat(this.indicadores);
    } else {
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
    }

    this.obtAvance();
    this.obtenerIndicadoresObj();
  }

}
